import React, {useEffect, useRef, useState} from 'react';
import Translate, {t} from '../../../../../../../components/Translate';
import './Integrations.css';
import {
    addTelegramBot,
    addWebexBot,
    attachInstagramPageToCompany,
    attachMessengerPageToCompany,
    deleteTelegramBot,
    deleteWebexBot,
    getAllPages,
    getInstagramAllPages,
    getInstagramBot,
    getMessengerBot,
    getTelegramBot,
    getViberBot,
    getWebexBot,
    getWhatsAppBot,
    handleFacebookLogin,
    handleFacebookLogout,
} from '../../../../../../../services/integrations/api';
import MessengerIcon from '../../../../../../../assets/icons/platforms/MessengerIcon'
import TelegramIcon from '../../../../../../../assets/icons/platforms/TelegramIcon'
import InstagramIcon from '../../../../../../../assets/icons/platforms/InstagramIcon'
import WebexIcon from '../../../../../../../assets/icons/platforms/WebexIcon'
import WhatsAppIcon from '../../../../../../../assets/icons/platforms/WhatsAppIcon'
import ViberIcon from '../../../../../../../assets/icons/platforms/ViberIcon'
import WebchatIcon from '../../../../../../../assets/icons/platforms/WebchatIcon'
import config from '../../../../../../../config';
import BlueButton from "../../../../../../../components-new/buttons/BlueButton";
import FacebookLoginButton from "../../../../../../../components-new/buttons/FacebookLoginButton";
import DestructiveButton from "../../../../../../../components-new/buttons/DestructiveButton";
import LoadingComponent from "../../../../../../../components-new/ui/LoadingComponent";
import Tabs from "../../../../../../../components-new/ui/Tabs";
import colors from "../../../../../../../utils/Colors";
import {Whatsapp} from "./components/Whatsapp";
import {Viber} from "./components/Viber";
import {WebChat} from "./components/WebChat";
import Input from "../../../../../../../components-new/form/Input";
import IntegrationSteps from "./components/IntegrationSteps";
import ConnectedBot from "./components/ConnectedBot";
import Accordion from "../../../../../../../components-new/ui/Accordion";
import AccordionItem from "../../../../../../../components-new/ui/Accordion/AccordionItem";
import CircleQuestionMarkIcon from "../../../../../../../assets/icons/CircleQuestionMarkIcon";
import MinusIcon from "../../../../../../../assets/icons/MinusIcon";
import PlusIcon from "../../../../../../../assets/icons/PlusIcon";


function Integrations({tariff, client, addNotification, user}) {

    const {messengers} = tariff;

    const [telegramBotToken, setTelegramBotToken] = useState("");
    const [telegramBot, setTelegramBot] = useState();

    const [webexBotToken, setWebexBotToken] = useState("");
    const [webexBot, setWebexBot] = useState();

    const [messengerBot, setMessengerBot] = useState();
    const [messengerPagesData, setMessengerPagesData] = useState();

    const [instagramBot, setInstagramBot] = useState();
    const [instagramPagesData, setInstagramPagesData] = useState();

    const [whatsAppBot, setWhatsAppBot] = useState({
        phoneNumberId: "",
        accessToken: "",
        verificationToken: "",
        accountId: "",
        appSecret: "",
        attached: false
    });

    const [viberBot, setViberBot] = useState({
        token: "",
        name: "",
        avatar: "",
        attached: false,
        fetched: false
    });

    const [activeTab, setActiveTab] = useState('webchat');
    const activePanelRef = useRef(null);
    const [activePanelMaxHeight, setActivePanelMaxHeight] = useState(null);

    const [isFacebookLoading, setIsFacebookLoading] = useState(false);


    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            if (messengers.includes(config.platformsMap.telegram)) {
                const telegramData = await getTelegramBot(client.id);
                if (telegramData !== "Not found") if (isMounted) setTelegramBot(telegramData);
            }

            if (messengers.includes(config.platformsMap.webex)) {
                const webexData = await getWebexBot(client.id);
                if (webexData !== "Not found") if (isMounted) setWebexBot(webexData);
            }

            if (messengers.includes(config.platformsMap.messenger) || messengers.includes(config.platformsMap.instagram)) {
                const messengerData = await getMessengerBot(client.id);
                if (messengerData !== "Not found") if (isMounted) setMessengerBot(messengerData);
                const fbPages = await getAllPages(client.id);
                if (fbPages !== "Not found") if (isMounted) setMessengerPagesData(fbPages);

                const instagramData = await getInstagramBot(client.id);
                if (instagramData !== "Not found") if (isMounted) setInstagramBot(instagramData);
                const instaPages = await getInstagramAllPages(client.id);
                if (instaPages !== "Not found") if (isMounted) setInstagramPagesData(instaPages);
            }

            if (messengers.includes(config.platformsMap.whatsapp)) {
                const whatsAppData = await getWhatsAppBot(client.id);
                if (whatsAppData !== "Not found") if (isMounted) setWhatsAppBot({
                    attached: whatsAppData && whatsAppData.phoneNumberId && whatsAppData.accessToken
                        && whatsAppData.verificationToken && whatsAppData.accountId && whatsAppData.appSecret,
                    ...whatsAppData
                })
            }

            if (messengers.includes(config.platformsMap.viber)) {
                const viberData = await getViberBot(client.id);
                if (viberData !== "Not found") if (isMounted) setViberBot({
                    attached: viberData && viberData.token,
                    fetched: true,
                    ...viberData
                })
            }
        };

        fetchData();

        return () => {
            isMounted = false;
        };
    }, [client.id]);

    useEffect(() => {
        const updateActivePanelHeight = () => {
            if (!activePanelRef.current) {
                setActivePanelMaxHeight(null);
                return;
            }

            const panelTop = activePanelRef.current.getBoundingClientRect().top;
            const sidebar = document.querySelector('.bots-sidebar');
            const bottom = sidebar
                ? sidebar.getBoundingClientRect().bottom
                : window.innerHeight;
            const nextHeight = Math.max(220, Math.floor(bottom - panelTop - 8));

            setActivePanelMaxHeight(nextHeight);
        };

        updateActivePanelHeight();
        const animationFrameId = window.requestAnimationFrame(updateActivePanelHeight);
        window.addEventListener('resize', updateActivePanelHeight);

        return () => {
            window.cancelAnimationFrame(animationFrameId);
            window.removeEventListener('resize', updateActivePanelHeight);
        };
    }, [activeTab]);


    // telegram
    const handleTelegramBotSave = () => {
        addTelegramBot(telegramBotToken, client.id).then(data => {
            updateTelegramBot();
            addNotification("added", config.notificationLevels.success)
        }).catch(() => {
            addNotification("somethingWentWrong", config.notificationLevels.error)
        });
    };

    const updateTelegramBot = () => {
        getTelegramBot(client.id).then(data => {
            if (data === "Not found") {
                return;
            }
            setTelegramBot(data);
        });
    };

    const onTelegramInputChange = (event) => {
        setTelegramBotToken(event.target.value);
    };

    const handleDeleteTelegramBot = () => {
        /* the row fades before it goes; the class is on .connected-bot now,
           and the guard is because it can be gone already */
        const row = document.querySelector('.connected-bot');
        if (row) row.classList.add('deleting');
        setTimeout(() => {
            deleteTelegramBot(client.id).then(data => {
                setTelegramBot(undefined);
                addNotification("deleted", config.notificationLevels.info)
            });
        }, 300);
    };
    //

    // webex
    const handleWebexBotSave = () => {
        addWebexBot(webexBotToken, client.id).then(data => {
            updateWebexBot();
            addNotification("added", config.notificationLevels.success)
        }).catch(() => {
            addNotification("somethingWentWrong", config.notificationLevels.error)
        });
    };

    const updateWebexBot = () => {
        getWebexBot(client.id).then(data => {
            if (data === "Not found") {
                return;
            }
            setWebexBot(data);
        });
    };

    const onWebexInputChange = (event) => {
        setWebexBotToken(event.target.value);
    };

    const handleDeleteWebexBot = () => {
        const row = document.querySelector('.connected-bot');
        if (row) row.classList.add('deleting');
        setTimeout(() => {
            deleteWebexBot(client.id).then(data => {
                setWebexBot(undefined);
                addNotification("deleted", config.notificationLevels.info)
            });
        }, 300);
    }
    //

    // facebook
    const handleFacebookLoginClick = (tokenData, companyId) => {
        setIsFacebookLoading(true);
        handleFacebookLogin(tokenData, companyId)
            .then(data => {
                setMessengerPagesData(data.messengerPages);
                setInstagramPagesData(data.instagramPages);
                addNotification("successful", config.notificationLevels.success);
            })
            .catch((error) => {
                if (
                    (error && error.response && error.response.data === "No pages found for this user") ||
                    (error && error.message === "No pages found for this user")
                ) {
                    addNotification("facebookLoginError1", config.notificationLevels.warning);
                } else {
                    addNotification("somethingWentWrong", config.notificationLevels.error);
                }
            })
            .finally(() => setIsFacebookLoading(false));
    };

    const handleFacebookLogoutClick = ({
                                           clientId,
                                           setMessengerPagesData,
                                           setMessengerBot,
                                           setInstagramBot,
                                           setInstagramPagesData,
                                           addNotification,
                                       }) => {
        return async function () {
            setIsFacebookLoading(true);
            try {
                await handleFacebookLogout(clientId);
                setMessengerPagesData(null);
                setMessengerBot(null);
                setInstagramBot(null);
                setInstagramPagesData(null);
                addNotification("deleted", config.notificationLevels.info);
            } catch (err) {
                addNotification("somethingWentWrong", config.notificationLevels.error);
            } finally {
                setIsFacebookLoading(false);
            }
        };
    };
    //

    // messenger
    const handleMessengerPageChange = ({
                                           clientId,
                                           messengerPagesData,
                                           setMessengerBot,
                                           addNotification,
                                       }) => {
        return async function (e) {
            const selectedPageId = e.target.value;

            try {
                await attachMessengerPageToCompany(clientId, selectedPageId);
                addNotification("successful", config.notificationLevels.success);

                if (selectedPageId === '') {
                    setMessengerBot(null);
                } else {
                    const selectedPage = messengerPagesData.find(page => page.pageId === selectedPageId);
                    setMessengerBot(selectedPage || null);
                }
            } catch (err) {
                if (err.response.data) {
                    const errorMessage = err.response.data;

                    if (errorMessage === 'Already attached to another bot') {
                        addNotification("thisPageAttachedToAnotherBot", config.notificationLevels.error);
                    } else if (errorMessage === 'Page not found') {
                        addNotification("pageNotFound", config.notificationLevels.error);
                    } else {
                        addNotification(errorMessage, config.notificationLevels.error);
                    }
                } else {
                    addNotification("somethingWentWrong", config.notificationLevels.error);
                }
            }
        };
    }
    //

    // instagram
    const handleInstagramPageChange = ({
                                           clientId,
                                           instagramPagesData,
                                           setInstagramBot,
                                           addNotification,
                                       }) => {
        return async function (e) {
            const selectedPageId = e.target.value;

            try {
                await attachInstagramPageToCompany(clientId, selectedPageId);
                addNotification("successful", config.notificationLevels.success);

                if (selectedPageId === '') {
                    setInstagramBot(null);
                } else {
                    const selectedPage = instagramPagesData.find(page => page.id === selectedPageId);
                    setInstagramBot(selectedPage || null);
                }
            } catch (err) {
                if (err.response.data) {
                    const errorMessage = err.response.data;

                    if (errorMessage === 'Already attached to another bot') {
                        addNotification("thisPageAttachedToAnotherBot", config.notificationLevels.error);
                    } else if (errorMessage === 'Page not found') {
                        addNotification("pageNotFound", config.notificationLevels.error);
                    } else {
                        addNotification(errorMessage, config.notificationLevels.error);
                    }
                } else {
                    addNotification("somethingWentWrong", config.notificationLevels.error);
                }
            }
        };
    }

    const tabs = [
        ...(messengers.includes(config.platformsMap.webchat) ? [{
            label: 'webchat',
            value: 'webchat',
            icon: WebchatIcon
        }] : []),
        ...(messengers.includes(config.platformsMap.telegram) ? [{
            label: 'telegram',
            value: 'telegram',
            icon: TelegramIcon
        }] : []),
        ...(messengers.includes(config.platformsMap.webex) ? [{label: 'webex', value: 'webex', icon: WebexIcon}] : []),
        ...(messengers.includes(config.platformsMap.messenger) ? [{
            label: 'messenger',
            value: 'messenger',
            icon: MessengerIcon
        }] : []),
        ...(messengers.includes(config.platformsMap.instagram) ? [{
            label: 'instagram',
            value: 'instagram',
            icon: InstagramIcon
        }] : []),
        ...(messengers.includes(config.platformsMap.whatsapp) ? [{
            label: 'whatsapp',
            value: 'whatsapp',
            icon: WhatsAppIcon,
            disabled: false
        }] : []),
        ...(messengers.includes(config.platformsMap.viber) ? [{
            label: 'viber',
            value: 'viber',
            icon: ViberIcon,
            disabled: false
        }] : [])
    ];

    return (
        <div className={'channels-parent-div'}>

            <div>
                <Tabs
                    selectedTab={activeTab}
                    onTabChange={setActiveTab}
                    tabs={tabs}
                    renderTab={tab => (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            opacity: tab.disabled ? 0.5 : 1
                        }}>
                            {/*
                              * Every icon here is a component now. Only the size
                              * is passed: a stroke was being handed to all of
                              * them, and on a brand mark - which is filled, not
                              * drawn in line - that laid an outline over the
                              * artwork and made it look badly cut out. Our own
                              * web chat icon takes currentColor by default, so
                              * it still follows the tab it sits in.
                              */}
                            <tab.icon width={26} height={26}
                                      style={{cursor: tab.disabled ? 'not-allowed' : 'pointer'}}/>
                        </div>
                    )}
                />
            </div>

            {messengers.includes(config.platformsMap.webchat) && activeTab === 'webchat' &&
                <WebChat client={client}/>
            }

            {messengers.includes(config.platformsMap.telegram) && activeTab === 'telegram' && (
                <div className="channel" style={{
                    justifyContent: 'flex-start',
                    alignItems: 'stretch',
                    minHeight: 'auto',
                    height: 'fit-content',
                    flex: '0 1 auto',
                    maxHeight: '65vh',
                    overflow: 'auto'
                }}>
                    <div style={{
                        width: '100%',
                        overflow: 'auto'
                    }}>
                        <div style={{display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'center'}}>
                            <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    <TelegramIcon width={40} height={40} style={{marginRight: '15px'}}/>
                                    <h2>
                                        Telegram
                                    </h2>
                                </div>

                                <IntegrationSteps steps={['telegramSetup1', 'telegramSetup2']}/>


                            </div>
                        </div>
                        {telegramBot && (
                            <ConnectedBot
                                name={telegramBot.name}
                                imageUrl={telegramBot.profile_image_url}
                                fallbackIcon={<TelegramIcon width={40} height={40}/>}
                                onDelete={handleDeleteTelegramBot}
                            />
                        )}
                        {!telegramBot && (
                            <div style={{width: '100%'}}>
                                <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                                    <div style={{width: '100%', maxWidth: '600px'}}>
                                        <Input
                                            disabled={!!telegramBot}
                                            type="text"
                                            name="botToken"
                                            placeholder='Bot Token'
                                            value={telegramBotToken}
                                            onChange={onTelegramInputChange}
                                            autoComplete={"off"}
                                            style={{
                                                width: '100%',
                                            }}
                                        />
                                    </div>
                                </div>
                                <div style={{display: 'flex', justifyContent: 'center'}}>
                                    <BlueButton
                                        styles={{marginTop: '20px'}}
                                        disabled={!!telegramBot}
                                        onClick={handleTelegramBotSave}
                                        width={'135px'}
                                        children={<Translate text={'save'}/>}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {messengers.includes(config.platformsMap.webex) && activeTab === 'webex' && (
                <div className="channel" style={{
                    justifyContent: 'flex-start',
                    alignItems: 'stretch',
                    minHeight: 'auto',
                    height: 'fit-content',
                    flex: '0 1 auto',
                    maxHeight: '65vh',
                    overflow: 'auto'
                }}>

                    <div style={{
                        width: '100%',
                        overflow: 'auto'
                    }}>
                        {/* the same centring row Telegram's block stands in - without
                            it this column hung at the left edge of a full-width div */}
                        <div style={{display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'center'}}>
                            <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    <WebexIcon width={40} height={40} style={{marginRight: '15px'}}/>
                                    <h2>Webex</h2>
                                </div>

                                <IntegrationSteps steps={['webexSetup1', 'webexSetup2', 'webexSetup3']}/>
                            </div>
                        </div>

                        {webexBot && (
                            <ConnectedBot
                                name={webexBot.name}
                                imageUrl={webexBot.profile_image_url}
                                fallbackIcon={<WebexIcon width={40} height={40}/>}
                                onDelete={handleDeleteWebexBot}
                            />
                        )}

                        {!webexBot && (
                            <div style={{width: '100%'}}>
                                <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                                    <div style={{width: '100%', maxWidth: '600px'}}>
                                        <Input
                                            disabled={!!webexBot}
                                            style={{width: '100%'}}
                                            type="text"
                                            name="botToken"
                                            placeholder='Bot Token'
                                            value={webexBotToken}
                                            onChange={onWebexInputChange}
                                            autoComplete={"off"}
                                        />
                                    </div>
                                </div>
                                <div style={{display: 'flex', justifyContent: 'center'}}>
                                    <BlueButton
                                        styles={{marginTop: '20px'}}
                                        disabled={!!webexBot}
                                        onClick={handleWebexBotSave}
                                        width={'135px'}
                                        children={<Translate text={'save'}/>}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {messengers.includes(config.platformsMap.messenger) && activeTab === 'messenger' && (
                <div style={{width: '100%', margin: '0 auto', minHeight: 0}}>
                    <div ref={activePanelRef} className="channel" style={{
                        justifyContent: 'flex-start',
                        alignItems: 'stretch',
                        minHeight: 'auto',
                        height: 'fit-content',
                        flex: '0 1 auto',
                        maxHeight: activePanelMaxHeight ? activePanelMaxHeight + 'px' : 'calc(100vh - 360px)',
                        marginTop: 0,
                        overflow: 'auto'
                    }}>
                        <div style={{
                            width: '100%',
                            overflow: 'auto'
                        }}>
                            <div style={{
                                maxWidth: '1200px',
                                margin: '0 auto',
                            }}>
                                <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                        <MessengerIcon width={40} height={40} style={{marginRight: '15px'}}/>
                                        <h2 style={{fontSize: '24px'}}>Messenger</h2>
                                    </div>
                                </div>

                                <Accordion
                                    defaultValue={'1'}
                                    style={{
                                        margin: '10px 0 20px 0'
                                    }}
                                >
                                    <AccordionItem
                                        value="1"
                                        triggerContent={
                                            <span className="integration-steps">
                                                <CircleQuestionMarkIcon/>
                                                <Translate text="integrationSteps"/>
                                            </span>
                                        }
                                        triggerIcon={({isOpen}) => {
                                            return isOpen() ?
                                                <MinusIcon style={{color: colors.silverBlue}} stroke="currentColor"
                                                           width={18} height={18}/> :
                                                <PlusIcon style={{color: colors.silverBlue}} stroke="currentColor"
                                                          width={18} height={18}/>
                                        }}
                                        itemStyle={{
                                            background: '#fafafa',
                                            borderRadius: '10px',
                                            padding: '12px 16px'
                                        }}
                                    >
                                        <div style={{
                                            padding: '10px 0 10px 34px',
                                            textAlign: 'justify',
                                            userSelect: 'text',
                                        }}>
                                            {user.language === 'en' ? (
                                                <ol style={{paddingLeft: '20px', margin: 0}}>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Log in with your <b>Facebook account</b>.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        You must be a <b>Facebook Page administrator</b> with full
                                                        permissions assigned via <b>Meta
                                                        Business Manager</b>. Simply being the Page creator is not
                                                        enough,
                                                        you must have the
                                                        <b> Admin role</b> on each Page you want to connect to the
                                                        chatbot.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        After login, select all <b>Facebook Pages</b> you may want to
                                                        use
                                                        now or in the future.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Then, select <b>Instagram Business or Creator accounts</b> that
                                                        are
                                                        properly connected
                                                        to those <b>Facebook Pages</b>.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Each <b>Instagram account</b> must be linked to a <b>Facebook
                                                        Page</b> via Instagram settings.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        On the connected Facebook Page, go to <b>Page Settings -> Linked
                                                        Accounts ->
                                                        Instagram</b>, and ensure the option <b>'Allow access to
                                                        Instagram
                                                        messages in Inbox'</b>
                                                        is turned ON.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        During Facebook login, make sure to grant <b>all requested
                                                        permissions</b>, including
                                                        access to <b>Facebook Pages</b>, <b>Instagram accounts</b>, and
                                                        messaging permissions for both
                                                        <b> Messenger</b> and <b>Instagram</b>.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Only after these steps will your Messenger and Instagram chatbot
                                                        integration
                                                        work correctly.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        If the Instagram account is not linked to a Facebook Page, it
                                                        won&apos;t appear.
                                                        If the Instagram messages setting is not enabled on the Page,
                                                        DMs
                                                        will not work.
                                                        If you are not an admin on the Page, you won&apos;t be able to
                                                        connect it to the chatbot.
                                                    </li>
                                                    <li>
                                                        <b>Logging out</b> will disconnect all linked bots.
                                                    </li>
                                                </ol>
                                            ) : (
                                                <ol style={{paddingLeft: '20px', margin: 0}}>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Մուտք գործեք ձեր <b>Facebook հաշիվը</b>։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Դուք պետք է լինեք <b>Facebook էջի ադմինիստրատոր</b>՝ բոլոր
                                                        իրավունքներով, որոնք տրված
                                                        են <b>Meta Business Manager</b>-ի միջոցով։ Միայն էջի ստեղծող
                                                        լինելը
                                                        բավարար չէ՝ դուք
                                                        պետք է ունենաք <b>Administrator</b> կարգավիճակ այն էջերում,
                                                        որոնք
                                                        ցանկանում եք կապել բոտին։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Մուտքից հետո ընտրեք բոլոր այն <b>Facebook էջերը</b>, որոնք
                                                        ցանկանում
                                                        եք օգտագործել հիմա
                                                        կամ ապագայում։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Այնուհետեւ ընտրեք <b>Instagram բիզնես կամ ստեղծագործողի
                                                        էջերը</b>,
                                                        որոնք ճիշտ կերպով
                                                        կապակցված են այդ <b>Facebook էջերին</b>։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Յուրաքանչյուր <b>Instagram էջ</b> պետք է կապված լինի <b>Facebook
                                                        էջի</b> հետ՝ Instagram-ի կարգավորումներում։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Գնացեք <b>Facebook էջի կարգավորումներ -> Linked Accounts ->
                                                        Instagram</b> բաժին և
                                                        միացրեք <b>'Allow access to Instagram messages in
                                                        Inbox'</b> (թույլատրել մուտք Instagram
                                                        հաղորդագրություններին) տարբերակը։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Մուտքի ժամանակ ընդունեք <b>բոլոր պահանջվող
                                                        թույլտվությունները</b>,
                                                        ներառյալ՝ <b>Facebook էջերին</b>,
                                                        <b> Instagram էջերին</b> և հաղորդագրություններին
                                                        հասանելիությունը
                                                        (<b>Messenger</b> և <b>Instagram</b>)։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Միայն այս քայլերից հետո Messenger և Instagram-ի ինտեգրումը բոտի
                                                        հետ
                                                        կաշխատի ճիշտ։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Եթե Instagram էջը կապակցված չէ Facebook էջին, այն չի երևա։ Եթե
                                                        հաղորդագրությունների
                                                        հասանելիությունը միացված չէ, Instagram DM-ները չեն աշխատի։ Եթե
                                                        դուք
                                                        ադմին չեք այդ
                                                        էջում, էջը չեք կարող կապել բոտին։
                                                    </li>
                                                    <li>
                                                        <b>Facebook-ից դուրս գալու</b> դեպքում բոլոր կապված բոտերը
                                                        կանջատվեն։
                                                    </li>
                                                </ol>
                                            )}
                                        </div>
                                    </AccordionItem>
                                </Accordion>


                                {messengerPagesData ? (
                                    <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                                        {messengerBot && (
                                            <div
                                                style={{
                                                    border: '1px solid var(--ds-border-secondary)',
                                                    borderRadius: '10px',
                                                    padding: '12px 16px',
                                                    marginBottom: '20px',
                                                    backgroundColor: '#fafafa',
                                                }}
                                            >
                                                <h4 style={{marginBottom: '5px', color: 'var(--ds-text-primary)'}}>
                                                    <Translate text="selectedPage"/>:
                                                </h4>
                                                <p style={{
                                                    margin: 0,
                                                    fontWeight: 'bold',
                                                    fontSize: '16px'
                                                }}>{messengerBot.pageName}</p>
                                            </div>
                                        )}

                                        <div style={{maxWidth: '400px', marginBottom: '25px'}}>
                                            <label htmlFor="messenger-page-select"
                                                   style={{fontWeight: '600', marginBottom: '10px', display: 'block'}}>
                                                <Translate text="selectPage"/>
                                            </label>
                                            <select
                                                id="messenger-page-select"
                                                className="form-control"
                                                style={{
                                                    padding: '10px 12px',
                                                    borderRadius: 'var(--ds-field-radius)',
                                                    border: '1px solid var(--ds-border-secondary)',
                                                    fontSize: 'var(--ds-body-2-size)',
                                                    backgroundColor: 'var(--ds-bg-primary)',
                                                }}
                                                value={(messengerBot && messengerBot.pageId) || ''}
                                                onChange={handleMessengerPageChange({
                                                    clientId: client.id,
                                                    messengerPagesData,
                                                    setMessengerBot,
                                                    addNotification,
                                                })}
                                            >
                                                <option value="">{t({text: 'detachPage', user})}</option>
                                                {messengerPagesData.map((page) => (
                                                    <option key={page.pageId} value={page.pageId}>
                                                        {page.pageName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {isFacebookLoading && (
                                            <LoadingComponent styles/>
                                        )}
                                        {!isFacebookLoading && (
                                            <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                                                <DestructiveButton
                                                    width="300px"
                                                    style={{
                                                        marginTop: '10px',
                                                    }}
                                                    onClick={handleFacebookLogoutClick({
                                                        clientId: client.id,
                                                        setMessengerPagesData,
                                                        setMessengerBot,
                                                        setInstagramBot,
                                                        setInstagramPagesData,
                                                        addNotification,
                                                    })}
                                                >
                                                    <Translate text="logoutFacebookAccount"/>
                                                </DestructiveButton>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <React.Fragment>
                                        {isFacebookLoading && (
                                            <LoadingComponent/>
                                        )}
                                        {!isFacebookLoading && (
                                            <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                                                <FacebookLoginButton handleFacebookLogin={handleFacebookLoginClick}
                                                                     client={client}/>
                                            </div>
                                        )}
                                    </React.Fragment>

                                )}

                            </div>
                        </div>
                    </div>
                </div>
            )}

            {messengers.includes(config.platformsMap.instagram) && activeTab === 'instagram' && (
                <div style={{width: '100%', margin: '0 auto', minHeight: 0}}>
                    <div ref={activePanelRef} className="channel" style={{
                        justifyContent: 'flex-start',
                        alignItems: 'stretch',
                        minHeight: 'auto',
                        height: 'fit-content',
                        flex: '0 1 auto',
                        maxHeight: activePanelMaxHeight ? activePanelMaxHeight + 'px' : 'calc(100vh - 360px)',
                        marginTop: 0,
                        overflow: 'auto'
                    }}>
                        <div style={{
                            width: '100%',
                            overflow: 'auto'
                        }}>
                            <div style={{
                                maxWidth: '1200px',
                                margin: '0 auto',
                            }}>
                                <div style={{display: 'flex', flexDirection: 'column', marginBottom: '20px'}}>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                        <InstagramIcon width={40} height={40} style={{marginRight: '15px'}}/>
                                        <h2 style={{fontSize: '24px'}}>Instagram</h2>
                                    </div>
                                </div>
                                <Accordion
                                    defaultValue={'1'}
                                    style={{
                                        margin: '10px 0 20px 0'
                                    }}
                                >
                                    <AccordionItem
                                        value="1"
                                        triggerContent={
                                            <span className="integration-steps">
                                        <CircleQuestionMarkIcon/>
                                        <Translate text="integrationSteps"/>
                                    </span>
                                        }
                                        triggerIcon={({isOpen}) => {
                                            return isOpen() ?
                                                <MinusIcon style={{color: colors.silverBlue}} stroke="currentColor"
                                                           width={18} height={18}/> :
                                                <PlusIcon style={{color: colors.silverBlue}} stroke="currentColor"
                                                          width={18} height={18}/>
                                        }}
                                        itemStyle={{
                                            background: '#fafafa',
                                            borderRadius: '10px',
                                            padding: '12px 16px'
                                        }}
                                    >
                                        <div style={{
                                            padding: '10px 0 10px 34px',
                                            textAlign: 'justify',
                                            userSelect: 'text',
                                        }}>
                                            {user.language === 'en' ? (
                                                <ol style={{paddingLeft: '20px', margin: 0}}>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Log in with your <b>Facebook account</b>.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        You must be a <b>Facebook Page administrator</b> with full
                                                        permissions assigned via <b>Meta
                                                        Business Manager</b>. Simply being the Page creator is not
                                                        enough,
                                                        you must have the
                                                        <b> Admin role</b> on each Page you want to connect to the
                                                        chatbot.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        After login, select all <b>Facebook Pages</b> you may want to
                                                        use
                                                        now or in the future.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Then, select <b>Instagram Business or Creator accounts</b> that
                                                        are
                                                        properly connected
                                                        to those <b>Facebook Pages</b>.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Each <b>Instagram account</b> must be linked to a <b>Facebook
                                                        Page</b> via Instagram settings.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        On the connected Facebook Page, go to <b>Page Settings -> Linked
                                                        Accounts ->
                                                        Instagram</b>, and ensure the option <b>'Allow access to
                                                        Instagram
                                                        messages in Inbox'</b>
                                                        is turned ON.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        During Facebook login, make sure to grant <b>all requested
                                                        permissions</b>, including
                                                        access to <b>Facebook Pages</b>, <b>Instagram accounts</b>, and
                                                        messaging permissions for both
                                                        <b> Messenger</b> and <b>Instagram</b>.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Only after these steps will your Messenger and Instagram chatbot
                                                        integration
                                                        work correctly.
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        If the Instagram account is not linked to a Facebook Page, it
                                                        won&apos;t appear.
                                                        If the Instagram messages setting is not enabled on the Page,
                                                        DMs
                                                        will not work.
                                                        If you are not an admin on the Page, you won&apos;t be able to
                                                        connect it to the chatbot.
                                                    </li>
                                                    <li>
                                                        <b>Logging out</b> will disconnect all linked bots.
                                                    </li>
                                                </ol>
                                            ) : (
                                                <ol style={{paddingLeft: '20px', margin: 0}}>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Մուտք գործեք ձեր <b>Facebook հաշիվը</b>։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Դուք պետք է լինեք <b>Facebook էջի ադմինիստրատոր</b>՝ բոլոր
                                                        իրավունքներով, որոնք տրված
                                                        են <b>Meta Business Manager</b>-ի միջոցով։ Միայն էջի ստեղծող
                                                        լինելը
                                                        բավարար չէ՝ դուք
                                                        պետք է ունենաք <b>Administrator</b> կարգավիճակ այն էջերում,
                                                        որոնք
                                                        ցանկանում եք կապել բոտին։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Մուտքից հետո ընտրեք բոլոր այն <b>Facebook էջերը</b>, որոնք
                                                        ցանկանում
                                                        եք օգտագործել հիմա
                                                        կամ ապագայում։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Այնուհետեւ ընտրեք <b>Instagram բիզնես կամ ստեղծագործողի
                                                        էջերը</b>,
                                                        որոնք ճիշտ կերպով
                                                        կապակցված են այդ <b>Facebook էջերին</b>։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Յուրաքանչյուր <b>Instagram էջ</b> պետք է կապված լինի <b>Facebook
                                                        էջի</b> հետ՝ Instagram-ի կարգավորումներում։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Գնացեք <b>Facebook էջի կարգավորումներ -> Linked Accounts ->
                                                        Instagram</b> բաժին և
                                                        միացրեք <b>'Allow access to Instagram messages in
                                                        Inbox'</b> (թույլատրել մուտք Instagram
                                                        հաղորդագրություններին) տարբերակը։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Մուտքի ժամանակ ընդունեք <b>բոլոր պահանջվող
                                                        թույլտվությունները</b>,
                                                        ներառյալ՝ <b>Facebook էջերին</b>,
                                                        <b> Instagram էջերին</b> և հաղորդագրություններին
                                                        հասանելիությունը
                                                        (<b>Messenger</b> և <b>Instagram</b>)։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Միայն այս քայլերից հետո Messenger և Instagram-ի ինտեգրումը բոտի
                                                        հետ
                                                        կաշխատի ճիշտ։
                                                    </li>
                                                    <li style={{marginBottom: '10px'}}>
                                                        Եթե Instagram էջը կապակցված չէ Facebook էջին, այն չի երևա։ Եթե
                                                        հաղորդագրությունների
                                                        հասանելիությունը միացված չէ, Instagram DM-ները չեն աշխատի։ Եթե
                                                        դուք
                                                        ադմին չեք այդ
                                                        էջում, էջը չեք կարող կապել բոտին։
                                                    </li>
                                                    <li>
                                                        <b>Facebook-ից դուրս գալու</b> դեպքում բոլոր կապված բոտերը
                                                        կանջատվեն։
                                                    </li>
                                                </ol>
                                            )}
                                        </div>
                                    </AccordionItem>
                                </Accordion>

                                {instagramPagesData ? (
                                    <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                                        {instagramBot && (
                                            <div
                                                style={{
                                                    border: '1px solid var(--ds-border-secondary)',
                                                    borderRadius: '10px',
                                                    padding: '12px 16px',
                                                    marginBottom: '20px',
                                                    backgroundColor: '#fafafa',
                                                }}
                                            >
                                                <h4 style={{marginBottom: '5px', color: 'var(--ds-text-primary)'}}>
                                                    <Translate text="selectedPage"/>:
                                                </h4>
                                                <p style={{
                                                    margin: 0,
                                                    fontWeight: 'bold',
                                                    fontSize: '16px'
                                                }}>{instagramBot.username}</p>
                                            </div>
                                        )}

                                        <div style={{maxWidth: '400px', marginBottom: '25px'}}>
                                            <label htmlFor="messenger-page-select"
                                                   style={{fontWeight: '600', marginBottom: '10px', display: 'block'}}>
                                                <Translate text="selectPage"/>
                                            </label>
                                            <select
                                                id="messenger-page-select"
                                                className="form-control"
                                                style={{
                                                    padding: '10px 12px',
                                                    borderRadius: 'var(--ds-field-radius)',
                                                    border: '1px solid var(--ds-border-secondary)',
                                                    fontSize: 'var(--ds-body-2-size)',
                                                    backgroundColor: 'var(--ds-bg-primary)',
                                                }}
                                                value={(instagramBot && instagramBot.id) || ''}
                                                onChange={handleInstagramPageChange({
                                                    clientId: client.id,
                                                    instagramPagesData,
                                                    setInstagramBot,
                                                    addNotification
                                                })}
                                            >
                                                <option value="">{t({text: 'detachPage', user})}</option>
                                                {instagramPagesData.map((page) => (
                                                    <option key={page.id} value={page.id}>
                                                        {page.username}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {isFacebookLoading && (
                                            <LoadingComponent/>
                                        )}
                                        {!isFacebookLoading && (
                                            <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                                                <DestructiveButton
                                                    width="300px"
                                                    style={{
                                                        marginTop: '10px',
                                                    }}
                                                    onClick={handleFacebookLogoutClick({
                                                        clientId: client.id,
                                                        setMessengerPagesData,
                                                        setMessengerBot,
                                                        setInstagramBot,
                                                        setInstagramPagesData,
                                                        addNotification,
                                                    })}
                                                >
                                                    <Translate text="logoutFacebookAccount"/>
                                                </DestructiveButton>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <React.Fragment>
                                        {isFacebookLoading && (
                                            <LoadingComponent/>
                                        )}
                                        {!isFacebookLoading && (
                                            <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                                                <FacebookLoginButton handleFacebookLogin={handleFacebookLoginClick}
                                                                     client={client}/>
                                            </div>
                                        )}
                                    </React.Fragment>
                                )}

                            </div>

                        </div>
                    </div>
                </div>
            )}

            {messengers.includes(config.platformsMap.whatsapp) && activeTab === 'whatsapp' && (
                <Whatsapp
                    client={client}
                    user={user}
                    whatsAppBot={whatsAppBot}
                    setWhatsAppBot={setWhatsAppBot}
                    addNotification={addNotification}
                />
            )}

            {messengers.includes(config.platformsMap.viber) && activeTab === 'viber' && (
                <Viber
                    client={client}
                    user={user}
                    viberBot={viberBot}
                    setViberBot={setViberBot}
                    addNotification={addNotification}
                />
            )}

        </div>
    );
}

export default Integrations;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/integrations/Integrations.jsx